import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import IconTooltip from '#client/components/IconTooltip';

export default function Title() {
  return (
    <Stack
      alignItems="center"
      direction="row"
      gap="4px"
      mb="16px"
    >
      <Text
        color="primary"
        size="md"
        weight="medium"
      >
        Daily balance
      </Text>
      <IconTooltip content="Balance updates with a 1-day lag." />
    </Stack>
  );
}
